export const DEFAULT_EXPERIENCE_PREFERENCE = {
  expCountries: [],
  expCities: [],
  expProducts: [],
  expMinPrice: 0,
  expMaxPrice: 0,
  expCategories: [],
  enableExpProducts: 0,
};

export const DEFAULT_VOUCHER_PREFERENCE = {
  voucherCountries: [],
  voucherCategories: [],
  voucherProducts: [],
  voucherMaxPrice: 0,
  voucherMinPrice: 0,
  enableVoucherProducts: 0,
};

export const DEFAULT_MERCHANDISE_PREFERENCE = {
  merchandiseCountries: [],
  merchandiseCategories: [],
  merchandiseProducts: [],
  merchandiseMaxPrice: 0,
  merchandiseMinPrice: 0,
  enableMerchandiseProducts: 0,
};

export const DEFAULT_PERKS_PREFERENCE = {
  perkCategories: [],
  perkCountries: [],
  perkProducts: [],
};

export const SITE_PREFERENCE = {
  redeemExperience: 1,
  redeemVoucher: 1,
  redeemPerk: 1,
  redeemMerchandise: 1,
  ...DEFAULT_EXPERIENCE_PREFERENCE,
  ...DEFAULT_PERKS_PREFERENCE,
  ...DEFAULT_VOUCHER_PREFERENCE,
  ...DEFAULT_MERCHANDISE_PREFERENCE,
};

export const DEFAULT_SITE_DATA = {
  expCategories: [],
  expCountries: [],
  perksCategories: [],
  perksCountries: [],
  voucherCategories: [],
  voucherCountries: [],
  merchandiseCategories: [],
  merchandiseCountries: [],
};

export const EXPERIENCE_PRODUCT = {
  expProdLoader: false,
  products: [],
  count: 0,
};

export const VOUCHER_PRODUCT = {
  voucherProdLoader: false,
  products: [],
  count: 0,
};

export const PERKS_PRODUCT = {
  perksProdLoader: false,
  products: [],
  count: 0,
};

export const MERCHANDISE_PRODUCT = {
  merchandiseProdLoader: false,
  products: [],
  count: 0,
};

export const DEFAULT_TEMPLATE = {
  album_id: 1,
  album_name: "Default",
  image_url:
    "http://xoxoday-testing.s3.amazonaws.com/store/template/default/e-gift-card-default.jpg",
  image_id: 1,
  company_id: "",
};

export const DEFAULT_EMAIL_TEMPLATE = {
  emailLogo: "",
  emailSubject: "Congratulations! You have received a reward.",
  emailHeading: "As a token of appreciation, here is your E-Gift Card!",
};

export const USER_MSG_CHAR_LIMIT = 600;
